/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

function AddToCart(currentThis, dynamicData) {
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: { 
      items: dynamicData,
      sections: 'cart-drawer'
    },
    dataType: "json",
    success: function (response) {
      $(".cdk_addToCart").removeClass("loading");
      $(".personalise_result .drawer_close").trigger("click");
      // Update cart drawer
      if (window.eventBus) {
        eventBus.emit('update:cart:drawer', response);
        eventBus.emit('open:cart:drawer', { scrollToTop: true });
      }
      // Update cart count - using the compare view
      $.ajax({
        url: '/cart?view=compare',
        type: 'GET',
        success: function(cart) {
          if (typeof cart === 'string') {
            try {
              cart = JSON.parse(cart);
            } catch(e) {
              console.error('Error parsing cart data:', e);
              return;
            }
          }
          
          if (window.wetheme && window.wetheme.updateCartCount) {
            window.wetheme.updateCartCount(cart);
          }
          
          // Fallback update for cart count indicator
          const cartCountIndicator = document.querySelector('[data-cart-count-indicator]');
          if (cartCountIndicator && cart.item_count !== undefined) {
            cartCountIndicator.textContent = cart.item_count;
            cartCountIndicator.classList.remove('hidden');
          }
        },
        error: function(xhr, status, error) {
          console.error('Error fetching cart count:', error);
        }
      });
    },
    error: function (jqXHR, textStatus, errorThrown) {
      if (jqXHR.status == 400) {
        alert(jqXHR.responseJSON.message);
      }
      if (jqXHR.status == 422) {
        alert(jqXHR.responseJSON.description);
      }
    },
  });
}


$(document).ready(function () {

    // $(document).on("click", ".faq-ques", function () {
    //   console.log('click')
    //   $(this).parents(".faq-ques-ans").siblings(".faq-ques-ans").find(".faq-ques").removeClass("active");
    //   $(this).parents(".faq-ques-ans").siblings(".faq-ques-ans").find(".faq-ans").slideUp();
    //   $(this).toggleClass("active");
    //   $(this).parents(".faq-ques-ans").find(".faq-ans").slideToggle();
    // });
  
  $(".personalise_button").click(function () {
    $(".personalise_drawer").fadeIn("slow");
    $("html,body").addClass("overflow-hidden");
    $('.wooden_add').click();
  });
  $(".drawer_close").click(function () {
    $(".personalise_drawer").fadeOut();
    $("html,body").removeClass("overflow-hidden");
  });

  $(".cdk-option").click(function () {
    $(this).addClass("active");
    $(this).next().slideDown("100", "linear");
    $(this).parents(".personalise_content").find(".text_option").slideDown("100", "linear");
  });
  $(document).on("click", ".accord-header:not(.package_header)", function () {
    $(this).toggleClass("active");
    $(this).next().slideToggle();
  });
  $(document).on("click", ".wooden_add", function () {
    $(this).toggleClass("active");
    const mainParent = $(this).closest('.personalise_drawer');
    const parent = $(this).closest('.package__content');
    const productParent = parent.find('.product_horizontal');
    const rotateContent = parent.find('.rotate-content');
    const textOption = parent.find('.text_option');
    const inputField = textOption.find('.engraving_input input[type="text"]');
    const counter = textOption.find('.input_counter');
    const maxLength = parseInt(inputField.attr("maxlength"), 10);
    const boxPrice = $('.package__content .product_horizontal').attr('box-product-price');
    const boxTextPrice = $('.package__content .product_horizontal').attr('box-text-price');
    const currentPrice = $('.personalise_price .original_price .current-price').text();
    const inputPrice = $('.personalise_price .original_price .current-price').attr('input_price');
    const varId = parent.find('.product_horizontal').attr('box-product-id');
    const boxId = mainParent.find('#cdk-box-product');
    if ($(this).hasClass("active")) {
      rotateContent.show();
      textOption.show();
      productParent.addClass('active');
      const grandTotal = parseFloat(currentPrice) + parseFloat(boxPrice);
      const subgrandTotal = grandTotal.toFixed(2);
      $('.personalise_price .original_price .current-price').text(subgrandTotal);
      boxId.val(varId);
      mainParent.find('.personalise_wrapper').addClass('active');
    } else {
      rotateContent.hide();
      textOption.hide();
      productParent.removeClass('active');
      inputField.val('').trigger('input').trigger('change').trigger('keyup');
      counter.text(`${maxLength}/${maxLength}`);
      boxId.val('');
      mainParent.find('.personalise_wrapper').removeClass('active');
      if (inputPrice == "true"){
        const grandTotal = parseFloat(currentPrice) - parseFloat(boxTextPrice);
        const  subgrandTotal = grandTotal.toFixed(2);
        $('.personalise_price .original_price .current-price').text(subgrandTotal);
      } else {
        const grandTotal = parseFloat(currentPrice) - parseFloat(boxPrice);
        const  subgrandTotal = grandTotal.toFixed(2);
        $('.personalise_price .original_price .current-price').text(subgrandTotal);
      }
    }
  });

  $(document).on("click", ".cork_add", function () {
    $(this).toggleClass("active");
    const mainParent = $(this).closest('.personalise_drawer');
    const parent = $(this).closest('.pick_cork_content');
    const productParent = parent.find('.product_horizontal');
    const corkPrice = parent.find('.product_horizontal').attr('corkscrew-product-price');
    const currentPrice = $('.personalise_price .original_price .current-price').text();
    const varId = parent.find('.product_horizontal').attr('corkscrew-product-id');
    const corkId = mainParent.find('#cdk-cork-product');
    const $this = $(this);
    const $mainImg = $("#cdk_main_img_prod");
    const $woodImg = $("#cdk_wood_img");
    const $text = $("#cdk_text_over_image");
    const mainImage = productParent.attr("main-image");
    const corkImage = productParent.attr("cork-image");
    const $pack = $(".package_option");
    const $image = $(".image-update");
    if ($(this).hasClass("active")) {
      productParent.addClass('active');
      const grandTotal = parseFloat(currentPrice) + parseFloat(corkPrice);
      const subgrandTotal = grandTotal.toFixed(2);
      $('.personalise_price .original_price .current-price').text(subgrandTotal);
      corkId.val(varId);
      $mainImg.attr("src", corkImage);
      $woodImg.hide();
      $text.hide();
      $mainImg.show();
      $pack.removeClass('woodimage');
      $image.removeClass('active');
    } else {
      productParent.removeClass('active');
      corkId.val('');
      const grandTotal = parseFloat(currentPrice) - parseFloat(corkPrice);
      const  subgrandTotal = grandTotal.toFixed(2);
      $('.personalise_price .original_price .current-price').text(subgrandTotal);
      $mainImg.attr("src", mainImage);
      $mainImg.hide();
      $woodImg.show();
      $text.show();
      $pack.addClass('woodimage');
    }
  });

  $(".cdk-option.active").click(function () {
    $(this).removeClass("active");
    $(this).next().slideUp("100", "linear");
    // var boxID =   $(this).parents('.personalise_main').find('#cdk-box-product').val();
    // var textBoxID =   $(this).parents('.personalise_main').find('#cdk-text-product').val();
  });
  let input = document.querySelector(".engraving_input input");
  counter = document.querySelector(".input_counter");
  maxLength = input.getAttribute("maxlength");
  counter.innerHTML = `${maxLength}/${maxLength}`;

  input.addEventListener("keyup", (e) => {
    counter.innerHTML = `${ parseFloat(maxLength) - e.target.value.length}/${maxLength}`;
  });
 
  $(document).on("click", ".package_image_block", function () {
    $(this).addClass("selected");
    var thisVarID = $(this).attr("box-product-id");
    var main_image = $(this).attr("data-image");
    var OriginalPrice = $('.cdk_product_image_box').attr('main-product-price');
    var thisPrice = $(this).next('.package_price').attr('wood-data-price');
    var totalPrice = parseFloat(OriginalPrice) + parseFloat(thisPrice);
    var subTotal = totalPrice.toFixed(2);
    // console.log("OriginalPrice::"+OriginalPrice+ "thisPrice::"+thisPrice);
    // console.log(totalPrice.toFixed(2));
    $("#cdk_main_img_prod").attr("src", main_image);
    $(this).parents(".packaging_option").next(".text_option").show();
    $(this).parents(".personalise_main").find("#cdk-box-product").val(thisVarID);
    $('.personalise_price .original_price .current-price').text(subTotal);
  });
  $(document).on("click",".ProductForm__Variants .ProductForm__Option .ColorSwatchList li label" ,function() { 
    var thisValue = $(this).prev('input').attr('value');
    console.log('thisValue::'+thisValue);
    var thisValueid = $('.product_card-form__master-select option[data-variant-main="'+thisValue+'"]').val();
    console.log('thisValueid::'+thisValueid);
    $('.product_card-form__master-select').val(thisValueid).change();
  });
  $(document).on('change', '.product_card-form__master-select', function(){
    var thisValue = $(this).val();
    // console.log("masthisValue::"+masthisValue);
    $(".personalise_main").find(".cdk_product_image_box").attr('main-product-id',thisValue);
    var thisValueImg = $('.product_card-form__master-select option[value ="'+thisValue+'"]').attr('datasrc');
    console.log("thisValueImg::"+thisValueImg);
    $('.main_product_image img').attr('src', thisValueImg);
    var displayPrice = $('.product_card-form__master-select option[value ="'+thisValue+'"]').attr('data-display-price');
    $('.main_product_image').next('.package_price').text(displayPrice);
    var thisPrice = $('.product_card-form__master-select option[value ="'+thisValue+'"]').attr('data-price');
    var woodPrice = $('.package_image_block').next('.package_price').attr('wood-data-price');
    console.log("thisPrice::"+thisPrice+ "woodPrice::"+woodPrice);
    var totalPrice = parseFloat(thisPrice) + parseFloat(woodPrice);
    var subTotal = totalPrice.toFixed(2);
    $('.personalise_price .original_price .current-price').text(subTotal);
  })
  $(document).on("click", ".cdk-text-option", function () {
    var textPrice = $('.text_content .text-varient-price').attr('data-text-price');
    var currentPrice = $('.personalise_price .original_price .current-price').text();
    var inputPrice = $('.personalise_price .original_price .current-price').attr("input_price");
    
    $(this).next(".package_content").find(".engraving_input input").val("");
    $("#cdk_text_over_image .cdk-dynamic-text").text("");
    $("#cdk-text-product").attr("data-text", "");
    // $("#cdk-text-product").val("");
    if (inputPrice == "true"){
      var grandTotal = parseFloat(currentPrice) - parseFloat(textPrice);
      var  subgrandTotal = grandTotal.toFixed(2);
      $('.personalise_price .original_price .current-price').text(subgrandTotal);
      $('.personalise_price .original_price .current-price').attr("input_price", "false");
    }
  });
  $(document).on("click", ".packaging_option .close_option", function () {
    var OriginalPrice = $('.cdk_product_image_box').attr('main-product-price');
    var textPrice = $('.text_content .text-varient-price').attr('data-text-price');
    var currentPrice = $('.personalise_price .original_price .current-price').text();
    var inputPrice = $('.personalise_price .original_price .current-price').attr("input_price");
    
    var thisMainID = $(".personalise_button").attr("main_product_id");
    var main_product_image = $(".personalise_button").attr("main_product_image");
    
    $(".package_image_block").removeClass("selected");
    $("#cdk_main_img_prod").attr("src", main_product_image);
    
    $(this).parents(".personalise_main").find("#cdk-box-product").val("");
    $(this).parents(".personalise_main").find("#cdk-text-product").val("");
    $(this).parents(".cdk-option").removeClass("active");
    $(this).parents(".packaging_option").find(".package_image_block").removeClass("selected");
    $(this).parents(".cdk-option").next().slideUp("100", "linear");
    $(this).parents(".personalise_content").find(".text_option").slideUp("100", "linear");
    
    $(".engraving_input input").val("");
    $(".cdk_product_image_box #cdk_text_over_image .cdk-dynamic-text").text("");
    if (inputPrice == "true"){
      var grandTotal = parseFloat(currentPrice) - parseFloat(textPrice);
      var  subgrandTotal = grandTotal.toFixed(2);
      $('.personalise_price .original_price .current-price').text(subgrandTotal);
      $('.personalise_price .original_price .current-price').attr("input_price", "false");
    }
    $('.personalise_price .original_price .current-price').text(OriginalPrice);
  });

  $(document).on("click", ".font_images .fornt_image_box", function () {
    $(this).parents(".font_images").find('.fornt_image_box').removeClass("selected");
    $(this).addClass("selected");
    var textProductID = $(this).attr("data-var-id");
    var dataFont = $(this).attr("data-family");
    // console.log("dataFont::"+dataFont);
    $("#cdk_text_over_image .cdk-dynamic-text").css("font-family", dataFont);
    $(this).parents(".personalise_main").find("#cdk-text-product").val(textProductID);
    $(this).parents(".personalise_main").find("#cdk-text-product").attr("data-font", dataFont);
  });
  $(document).on("click", ".image-changer .image-update", function () {
    const $this = $(this);
    const $mainImg = $("#cdk_main_img_prod");
    const $woodImg = $("#cdk_wood_img");
    const $text = $("#cdk_text_over_image");
    const $pack = $(".package_option");
    const mainImage = $this.find('.button-image').attr("src");
    console.log("mainImage::"+mainImage);
    $('.image-update').removeClass('active');
    $this.addClass("active")

    if ($this.hasClass("active")) {
      $mainImg.attr("src", mainImage);
      $woodImg.hide();
      $text.hide();
      $mainImg.show();
      $pack.removeClass('woodimage');
    } else {
      $mainImg.hide();
      $woodImg.show();
      $text.show();
      $pack.addClass('woodimage');
    }
  });

  $(document).on("click", ".package_option", function () {
    const $this = $(this);
    const $mainImg = $("#cdk_main_img_prod");
    const $woodImg = $("#cdk_wood_img");
    const $text = $("#cdk_text_over_image");
    const $image = $(".image-update");

    if ($this.hasClass("woodimage")) {
      // $woodImg.hide();
      // $text.hide();
      // $mainImg.show();
    } else {
      $mainImg.hide();
      $woodImg.show();
      $text.show();
      $this.addClass('woodimage');
      $image.removeClass('active');
    }
  });

   $(".engraving_input input").keyup(function () {
      var text = $(this).val();
      var textLength = text.length;
      var textPrice = $('.text_content .text-varient-price').attr('data-text-price');
      var currentPrice = $('.personalise_price .original_price .current-price').text();
      var inputPrice = $('.personalise_price .original_price .current-price').attr("input_price");
      $(this).parents(".personalise_main").find("#cdk-text-product").attr("data-text", text);
      if (textLength >= 1 && inputPrice == "false"){ 
      var grandTotal = parseFloat(currentPrice) + parseFloat(textPrice);
      var  subgrandTotal = grandTotal.toFixed(2);
        // console.log('grandTotal::'+grandTotal);
      $('.js-function-toggle').show();
      $('.personalise_price .original_price .current-price').text(subgrandTotal);
      $('.personalise_price .original_price .current-price').attr("input_price", "true");
      } 
      else if (textLength == 0 && inputPrice == "true"){
        var grandTotal = parseFloat(currentPrice) - parseFloat(textPrice);
         var  subgrandTotal = grandTotal.toFixed(2);
        $('.personalise_price .original_price .current-price').text(subgrandTotal);
        $('.personalise_price .original_price .current-price').attr("input_price", "false");
        $('.js-function-toggle').hide();
      }
      // Your new logic to add/remove "break" class
      if (textLength > 6) {
          $('.cdk-dynamic-text-vertical').addClass('break');
      } else {
          $('.cdk-dynamic-text-vertical').removeClass('break');
      }
      // if (textLength > 0) {
      //     $('.image-changer').hide();
      // } else {
      //     $('.image-changer').show();
      // }
   })
  // Get the input and output elements
  var $inputText = $('.personalise_wrapper .engraving_input input');
  var $outputText = $('#cdk_text_over_image .cdk-dynamic-text');
  var $inputTextVertical = $('.personalise_wrapper.vertical-view .engraving_input input');
  var $outputTextVertical = $('#cdk_text_over_image .cdk-dynamic-text-vertical');
  // Function to update the output element with the input value
  function updateOutput() {
    var inputValueVertical = $inputTextVertical.val();
    $outputTextVertical.text(inputValueVertical);
    var inputValue = $inputText.val();
    $outputText.text(inputValue);
    
  }
  // Function to adjust font size based on input length Desktop
  function adjustFontSize() {
    var inputLength = $inputText.val().length;
    // console.log("inputLengthHori::"+inputLength);
    var fontSize = 74 - (inputLength * 5.5);
    var fontSizeVer = 64 - (inputLength * 5.5); // Adjust the multiplier as needed
    // Set a minimum font size to avoid making it too small
    fontSize = Math.max(fontSize, 28);
    fontSizeVer = Math.max(fontSizeVer, 16);
    $outputText.css('font-size', fontSize + 'px');
    $outputTextVertical.css('font-size', fontSizeVer + 'px');
  }
  // Function to adjust font size based on input length mobile
  function adjustFontSizeMobile() {
    
    var inputLength = $inputText.val().length;
    // console.log("inputLengthHori::"+inputLength);
    var fontSize = 40 - (inputLength * 2);
    var fontSizeVer = 25 - (inputLength * 2);// Adjust the multiplier as needed
    // Set a minimum font size to avoid making it too small
    fontSize = Math.max(fontSize, 22);
    fontSizeVer = Math.max(fontSizeVer, 10);
    $outputText.css('font-size', fontSize + 'px');
    $outputTextVertical.css('font-size', fontSizeVer + 'px');
  }
  
  // function cdkUpdateFontSize() {
    
  // }
  // Initial setup
  updateOutput();
  if  ($(window).width() <= 580) {
      adjustFontSizeMobile();
    }
  else{
     adjustFontSize();
  }
 
 // Event listener for input change
  $inputText.on('input', function() {
    updateOutput();    
    if  ($(window).width() <= 580) {
      adjustFontSizeMobile();
    }
    else{
       adjustFontSize();
    }
  });
  // $inputTextVertical.on('input', function() {
  //   console.log('on');
  //   updateOutput();    
  //   if  ($(window).width() <= 580) {
  //     adjustFontSizeMobileVertical();
  //   }
  //   else{
  //     adjustFontSizeVertical();
  //   }
  // });
  // Event listener for window resize
  $(window).on('resize', function() {
     if  ($(window).width() <= 580) {
      var windowWidth = $(window).width();
      var fontSize = windowWidth / 20; // You can adjust this formula to suit your needs
      $('#cdk_text_over_image .cdk-dynamic-text').css('font-size', fontSize + 'px');
       var fontSizeVer = windowWidth / 32; // You can adjust this formula to suit your needs
      $('.cdk_product_image_box.vertical-view #cdk_text_over_image .cdk-dynamic-text-vertical').css('font-size', fontSizeVer + 'px');
    }
   else if  ($(window).width() <= 767) {
      var windowWidth = $(window).width();
      var fontSize = windowWidth / 25; // You can adjust this formula to suit your needs
      $('#cdk_text_over_image .cdk-dynamic-text').css('font-size', fontSize + 'px');
       var fontSizeVer = windowWidth / 40; // You can adjust this formula to suit your needs
      $('.cdk_product_image_box.vertical-view #cdk_text_over_image .cdk-dynamic-text-vertical').css('font-size', fontSizeVer + 'px');
    }
    else if ($(window).width() <= 1024) {
     var windowWidth = $(window).width();
    var fontSize = windowWidth / 30; // You can adjust this formula to suit your needs
    $('#cdk_text_over_image .cdk-dynamic-text').css('font-size', fontSize + 'px');
       var fontSizeVer = windowWidth / 60; // You can adjust this formula to suit your needs
      $('.cdk_product_image_box.vertical-view #cdk_text_over_image .cdk-dynamic-text-vertical').css('font-size', fontSizeVer + 'px');
    }
    else if ($(window).width() <= 1200) {
     var windowWidth = $(window).width();
      var fontSizeVer = windowWidth / 50; // You can adjust this formula to suit your needs
      $('.cdk_product_image_box.vertical-view #cdk_text_over_image .cdk-dynamic-text-vertical').css('font-size', fontSizeVer + 'px');
    }
    
    else{
      adjustFontSize();
    }
  });
  
  $(document).on("click", ".cdk_addToCart", function () {
    var currentThis = $(this);
    var updateItems = [];
    var mainProduct = currentThis.parents(".personalise_drawer").find(".personalise_result .cdk_product_image_box").attr("main-product-id");
    var boxProduct = currentThis.parents(".personalise_drawer").find(".personalise_main #cdk-box-product").val();
    var corkProduct = currentThis.parents(".personalise_drawer").find(".personalise_main #cdk-cork-product").val();
    var textProduct = currentThis.parents(".personalise_drawer").find(".personalise_main #cdk-text-product").val();
    var inputText = currentThis.parents(".personalise_drawer").find(".personalise_main #cdk-text-product").attr("data-text");
    var inputTextType = currentThis.parents(".personalise_drawer").find(".personalise_main #cdk-text-product").attr("data-text-type");
    var fontFamily = currentThis.parents(".personalise_drawer").find(".personalise_main #cdk-text-product").attr("data-font");
    // var textquantity = 1;
    var quantity = currentThis.parents(".main_product_personaliser").find('.product-section .product-details-wrapper .product-form-block quantity-input .js-qty__num').val();
    // console.log("lastQty::"+lastQty);
    // console.log("boxProduct::"+boxProduct);
    // console.log("textProduct::"+textProduct);
    // console.log("textLength::"+textLength);
    // Generate a unique timestamp
    var timestamp = Date.now();
    if (textProduct != "" && inputText != "") {
      updateItems.push({
        id: textProduct,
        quantity: quantity,
        properties: {
          "Personalize Text": inputText,
          "Personalize-fonts": fontFamily,
          "Personalize Text type": inputTextType,
          "_timestamp": timestamp, // Add the timestamp here
        },
      });
    }
    if (boxProduct != "") {
      updateItems.push({
        id: boxProduct,
        quantity: quantity,
        properties: {
          "_timestamp": timestamp // Add the same timestamp here
        },
      });
    }

    if (corkProduct != "") {
      updateItems.push({
        id: corkProduct,
        quantity: quantity,
        properties: {
          "_timestamp": timestamp
        },
      });
    }
    
    updateItems.push({ id: mainProduct, quantity: quantity });
    $(this).addClass('loading');
    AddToCart(currentThis, updateItems);
  });

  $(document).on('click','.rotate-content[for="vertical"]',function() {
    var buttonText = $(this).find('.btn').text();
    var fontSizeset = $('.cdk-dynamic-text.cdk-dynamic-text-vertical').css('font-size');
    // console.log('buttonText::'+buttonText);
    $(this).attr("for", "horizontal");
    if (buttonText == 'see vertical'){
      $(this).find('.btn').text('see horizontal');
    }
    else{
     $(this).find('.btn').text('see vertical'); 
    }
    $('#cdk-text-product').attr('data-text-type', 'Vertical');
    $('.personalise_result .cdk_product_image_box, .personalise_wrapper').removeClass('hr-view');
    $('.personalise_result .cdk_product_image_box, .personalise_wrapper').addClass('vertical-view');
    $('.cdk-dynamic-text.cdk-dynamic-text-horizontal').hide();
    $('.cdk-dynamic-text.cdk-dynamic-text-vertical').show();
    
  })
  $(document).on('click','.rotate-content[for="horizontal"]',function() {
    var buttonText = $(this).find('.btn').text();
     $(this).find('.btn').text('see vertical'); 
    $(this).attr("for", "vertical");
    $('#cdk-text-product').attr('data-text-type', 'Horizontal');
    $('.personalise_result .cdk_product_image_box, .personalise_wrapper').addClass('hr-view');
    $('.personalise_result .cdk_product_image_box, .personalise_wrapper').removeClass('vertical-view');
    $('.cdk-dynamic-text.cdk-dynamic-text-horizontal').show();
    $('.cdk-dynamic-text.cdk-dynamic-text-vertical').hide();
  })
  
  
});

function validateAndRemoveGiftProduct() {
  const giftProductVariantId = $("#cdk-text-product").attr("data-product-id"); // Gift product ID
  const specificProductVariantId = $("#cdk-box-product").attr("data-product-id"); // Required specific product ID

  console.log("giftProductVariantId:", giftProductVariantId);
  console.log("specificProductVariantId:", specificProductVariantId);
  console.log("Starting validateAndRemoveGiftProduct...");

  // Fetch the cart details
  return $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json'
  }).then(function(cart) {
    console.log("Cart data fetched:", cart);

    // Identify gift products and specific products in the cart
    const giftProducts = cart.items.filter(item => item.product_id.toString() === giftProductVariantId);
    const specificProducts = cart.items.filter(item => item.product_id.toString() === specificProductVariantId);

    if (giftProducts.length === 0) {
      console.log("No gift products found in the cart.");
      return Promise.resolve(); // No gift products to process
    }

    if (specificProducts.length === 0) {
      console.log("No specific products found in the cart. Removing all gift products.");
      // If no specific product exists, remove all gift products
      return removeProductsFromCart(giftProducts);
    }

    console.log("Gift products found:", giftProducts);
    console.log("Specific products found:", specificProducts);

    // Filter out gift products that do not have a matching _timestamp with any specific product
    const unmatchedGiftProducts = giftProducts.filter(giftProductItem => {
      const giftTimestamp = giftProductItem.properties?._timestamp;
      const isMatchingTimestamp = specificProducts.some(specificProductItem => 
        specificProductItem.properties?._timestamp && 
        giftTimestamp && 
        specificProductItem.properties._timestamp === giftTimestamp
      );

      if (!isMatchingTimestamp) {
        console.log(`No matching _timestamp for gift product with key: ${giftProductItem.key}. It will be removed.`);
        return true; // This gift product will be removed
      } else {
        console.log(`Matching _timestamp found for gift product with key: ${giftProductItem.key}. It will not be removed.`);
        return false; // This gift product stays in the cart
      }
    });

    // If no unmatched gift products exist, exit early
    if (unmatchedGiftProducts.length === 0) {
      console.log("All gift products have matching timestamps. No products to remove.");
      return Promise.resolve();
    }

    // Remove unmatched gift products from the cart
    return removeProductsFromCart(unmatchedGiftProducts);

  }).catch(function(error) {
    $('.cart-drawer__footer--button').removeClass('loading');
    console.error("Error fetching cart:", error);
  });
}

// Helper function to remove multiple products from the cart
function removeProductsFromCart(productsToRemove) {
  const removalPromises = productsToRemove.map(product => {
    console.log(`Removing gift product with key: ${product.key}`);
    return $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: product.key, // Unique key for the cart item
        quantity: 0 // Remove the item
      },
      dataType: 'json'
    }).then(function(response) {
      console.log(`Gift product with key: ${product.key} removed successfully.`, response);
    }).catch(function(error) {
      console.error(`Error removing gift product with key: ${product.key}.`, error);
    });
  });

  return Promise.all(removalPromises).then(() => {
    $('.cart-drawer__footer--button').removeClass('loading');
    console.log("Finished processing all unmatched gift products.");
  });
}

// Event listeners for cart changes
$(document).on('click', '.cart-drawer__product-card--remove, .cart-drawer__product-card--quantity--button', function(event) {
  $('.cart-drawer__footer--button').addClass('loading');
  setTimeout(function() {
    validateAndRemoveGiftProduct();
  }, 1000);
});

$(document).on('change', '.cart-drawer__product-card--quantity--input', function(event) {
  $('.cart-drawer__footer--button').addClass('loading');
  setTimeout(function() {
    validateAndRemoveGiftProduct();
  }, 1000);
});

// Initial validation
validateAndRemoveGiftProduct();

